import { render, staticRenderFns } from "./HeaderV2ProjectListAtom.vue?vue&type=template&id=012ede8b&scoped=true&lang=pug&"
import script from "./HeaderV2ProjectListAtom.vue?vue&type=script&lang=ts&"
export * from "./HeaderV2ProjectListAtom.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderV2ProjectListAtom.vue?vue&type=style&index=0&id=012ede8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ede8b",
  null
  
)

export default component.exports